export default __webpack_public_path__ + "static/media/OO_logo_wo_safespace_Primary - Color.cfe6060d.png";